<template>
  <div>
    <div class="link-button-box">
      <ButtonToNewLoginInfo />
      <ButtonToLoginInfo />
    </div>
    <div class="exam-result">
      <div class="exam-result-header">
        <h2 class="exam-result-title">試験結果一覧</h2>
        <span class="access-date"> {{ accessDate }} </span>
        <span class="reget-exam-result" @click="getExamResults()">
          <img class="reload-icon" :src="reload">
        </span>
        <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="exam_result_table"
        size="sm"
        align="center"
        />
        <div class="search-filter-sort-block">
          <div class="search-filter-sort">
            <label class="search-filter-sort-label">受験者：</label>
            <input
              class="search-form-input"
              type="text"
              v-model="searchApplicant"
            >
          </div>
          <div class="search-filter-sort">
            <label class="search-filter-sort-label">採点者：</label>
            <input
              class="search-form-input"
              type="text"
              v-model="searchRecruiter"
            >
          </div>
          <div class="search-filter-sort">
            <label class="search-filter-sort-label">採点結果：</label>
            <select class="filter-sort-select" v-model="selectedScoring">
              <option value="">-</option>
              <option v-for="scoring in scoringList" :key="scoring">
                {{ scoring }}
              </option>
            </select>
          </div>
          <b-button
            class="search-filter-sort"
            variant="primary"
            @click="resetFilterSort"
          >
            リセット
          </b-button>
          <div class="search-filter-sort">
            <label class="search-filter-sort-label">並べ替え：</label>
            <select class="filter-sort-select" v-model="sortSelect">
              <option
                v-for="option in sortOptions"
                :key="option.text"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <b-table
        id="exam_result_table"
        :fields="fields"
        :items="filteredExamResults"
        :per-page="perPage"
        :current-page="currentPage"
        small
        striped
        hover
      >
        <template #cell(scoring)="data">
          <div v-if="data.item.maybeScoring === null">
            未採点
          </div>
          <div v-else>
            <b> {{ data.item.maybeScoring }} </b>
            ( {{ data.item.maybeRecruiterName }} )
          </div>
        </template>
        <template #cell(linkToScoring)="data">
            <div
              v-if="data.item.maybeBestPassCase !== null && data.item.maybeLastPassCase !== null"
              class="active-link-to-scoring"
            >
              <a
                :href="'admin/scoring_input?applicant_id='
                + data.item.applicantId"
              >
                採点入力
              </a>
            </div>
            <div v-else class="inactive-link-to-scoring">
              採点入力
            </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="exam_result_table"
        size="sm"
        align="center"
      />
    </div>
  </div>
</template>

<script>
import ButtonToLoginInfo
  from '@/main/frontend/components/ButtonToLoginInfo.vue';
import ButtonToNewLoginInfo
  from '@/main/frontend/components/ButtonToNewLoginInfo.vue';
import reload from '@/main/frontend/assets/reload.png';

// bestPassCase を BestPassCase に変換して結合するために追加
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export default {
  components: {
    ButtonToLoginInfo,
    ButtonToNewLoginInfo,
  },
  data() {
    return {
      accessDate: null,
      reload: reload,
      searchApplicant: '',
      searchRecruiter: '',
      selectedScoring: '',
      sortSelect: 'newer',
      scoringList: [
        '好通過',
        '通過',
        '非通過',
        '未採点',
      ],
      sortOptions: [
        {value: 'newer', text: '登録が新しい順'},
        {value: 'older', text: '登録が古い順'},
      ],
      perPage: 10,
      currentPage: 1,
      fields: [
        {key: 'applicantName', label: '受験者名'},
        {key: 'examName', label: '試験名'},
        {key: 'applicantStatus', label: '試験実施状況'},
        {
          key: 'time', label: '時間',
          formatter: (value, key, item) => {
            switch (item.applicantStatus) {
            case '試験中':
              return item.maybeStartTime.slice(0, -3) + ' 開始';
            case '試験後':
              return item.maybeEndTime.slice(0, -3) + ' 終了';
            default:
              return '未実施';
            }
          },
        },
        {
          key: 'bestPassCase', label: '最高TC通過数',
          formatter: this.passCaseFromatter,
        },
        {
          key: 'lastPassCase', label: '最終TC通過数',
          formatter: this.passCaseFromatter,
        },
        {key: 'scoring', label: '開発者の採点結果'},
        {key: 'linkToScoring', label: '開発者の採点入力'},
      ],
      examResults: [{
        applicantId: '',
        applicantName: '',
        examName: '',
        applicantStatus: '',
        maybeBestPassCase: null,
        maybeLastPassCase: null,
        maybeTotalBestTestCase: null,
        maybeTotalLastTestCase: null,
        maybeScoring: '',
        maybeStartTime: null,
        maybeEndTime: null,
        maybeRecruiterName: '',
      }],
    };
  },
  mounted() {
    this.getExamResults();
  },

  computed: {
    rows() {
      return this.filteredExamResults.length;
    },
    filteredExamResults() {
      const filteredExamResults = this.examResults.filter((item) => {
        return item.applicantName.includes(this.searchApplicant) &&
          (
            // 採点者名での検索
            // 検索窓が空文字の時は全件 True
            // 採点者名が null ではない時は、
            // 検索窓に入力された文字を部分文字列として含む場合 True
            // null に対して includes を呼ぶとエラーになるので回避する書き方
            this.searchRecruiter === '' ||
            (item.maybeRecruiterName &&
            item.maybeRecruiterName.includes(this.searchRecruiter))
          ) &&
          (
            // 採点結果でのフィルタ
            // フィルタの value が空文字の時は全件True
            // フィルタの value が選択されている時は、選択された採点結果のみ True
            // フィルタで 未採点 が選択されている時は、maybeScoring が null で True
            this.selectedScoring === '' ||
            item.maybeScoring === this.selectedScoring ||
            (this.selectedScoring === '未採点' && item.maybeScoring === null)
          );
      });
      const coloredExamResults = this.coloringCells(filteredExamResults);
      let sortedExamResults = coloredExamResults;
      if (this.sortSelect === 'older') {
        sortedExamResults = sortedExamResults.slice().reverse();
      }
      return sortedExamResults;
    },
  },
  methods: {
    getExamResults() {
      const date = new Date();
      const accessDate = date.getFullYear() + '/' +
        (date.getMonth() + 1) + '/' +
        date.getDate() + ' ' +
        date.getHours() + ':' +
        ('00' + date.getMinutes()).slice(-2);
      this.accessDate = accessDate;

      this.$axios
        .get('/api/exam_result/index')
        .then((response) => {
          this.examResults = response.data;
        });
    },
    resetFilterSort() {
      this.searchApplicant = '';
      this.searchRecruiter = '';
      this.selectedScoring = '';
    },
    coloringCells(filteredExamResults) {
      filteredExamResults = filteredExamResults.map((item) => {
        item._cellVariants = {};
        return item;
      });

      filteredExamResults = this.coloringPassCase(
        'bestPassCase', filteredExamResults,
      );
      filteredExamResults = this.coloringPassCase(
        'lastPassCase', filteredExamResults,
      );
      filteredExamResults = this.coloringScoring(filteredExamResults);
      return filteredExamResults;
    },
    coloringPassCase(key, filteredExamResults) {
      const columnName = 'maybe'+key.capitalize();
      const totalColumnName = 'maybeTotal' +
        key.capitalize().replace('Pass', 'Test');
      return filteredExamResults.map((item) => {
        if (item[columnName] === null) {
          return item;
        }
        const bestAcceptRate = item[columnName] / item[totalColumnName];
        // NOTE: 色分けの基準となる正解率は、3色なので1/3ずつで決め打ちしてる
        if (bestAcceptRate <= 1/3) {
          item._cellVariants[key] = 'danger';
        } else if (bestAcceptRate <= 2/3) {
          item._cellVariants[key] = 'warning';
        } else {
          item._cellVariants[key] = 'success';
        }
        return item;
      });
    },
    coloringScoring(filteredExamResults) {
      return filteredExamResults.map((item) => {
        switch (item.maybeScoring) {
        case '非通過':
          item._cellVariants['scoring'] = 'danger';
          break;
        case '通過':
          item._cellVariants['scoring'] = 'warning';
          break;
        case '好通過':
          item._cellVariants['scoring'] = 'success';
          break;
        default:
        }
        return item;
      });
    },
    passCaseFromatter(value, key, item) {
      const columnName = 'maybe'+key.capitalize();
      const totalColumnName = 'maybeTotal' +
        key.capitalize().replace('Pass', 'Test');
      if (item[columnName] === null) {
        return 'テスト実行前';
      }
      return item[columnName] + ' / ' + item[totalColumnName];
    },
  },
};
</script>

<style scoped>
.exam-result {
  margin: 15px 15px 0;
}
.exam-result-header {
  overflow: hidden;
}
.exam-result-title {
  display: inline-block;
  font-size: 20px;
}
.access-date {
  margin-left: 15px;
}
.reget-exam-result {
  border-radius: 3px;
  cursor: pointer;
  display: inline-block;
  margin-left: 8px;
  width: 24px;
}
.reget-exam-result:active {
  background-color: #6c757d;
}
.reload-icon {
  margin: 0 0 4px 4px;
  width: 16px;
}
.search-filter-sort-block {
  text-align: center;
}
.search-filter-sort {
  margin: 10px;
  display: inline-block;
}
.search-filter-sort-label {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0;
  padding: 0.375rem 0.75rem;
}
.search-form-input {
  border: 1px solid #ced4da;
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0.375rem 0.75rem;
}
.search-form-input:focus {
  outline: none;
}
.filter-scoring-label {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0;
  padding: 0.375rem 0.75rem;
}
.filter-sort-select {
  border: 1px solid #ced4da;
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0.375rem 0.75rem;
}
.inactive-link-to-scoring {
  color: #6c757d;
}
</style>
